import React, { ReactElement } from 'react'
import classNames from 'classnames'

export enum DiscountLabelAlignment {
  Left,
  Right,
}

interface DiscountLabelProps {
  discount: string
  alignment: DiscountLabelAlignment
  large: boolean
}

export function DiscountLabel(props: DiscountLabelProps): ReactElement {
  return (
    <div
      className={classNames('absolute top-[15px] z-10 bg-highlight-red text-right text-white', {
        'right-0 rounded-l-md': props.alignment === DiscountLabelAlignment.Right,
        'left-0 rounded-r-md': props.alignment === DiscountLabelAlignment.Left,
        'px-2 pb-2 pt-1': !props.large,
        'px-4 pb-4 pt-3 md:px-6': props.large,
      })}
    >
      <div
        className={classNames('-mb-1.5 text-xl', {
          'font-bold': props.large,
          'font-regular': !props.large,
        })}
      >
        {props.discount}
      </div>
    </div>
  )
}
